import { ADMIN_LIQUIDATION_QUEUE } from './mockAdapter';

export type LiquidationWorkflowStatus = 'not_started' | 'in_progress' | 'liquidated';

export interface LiquidationQueueEntry {
  id: string;
  facilityName: string;
  accountId: string;
  wallet: string;
  collateralAmount: number;
  debtAmount: number;
  healthFactor: number;
  timeInDefault: string;
  status: LiquidationWorkflowStatus;
  hasDdf: boolean;
}

export const INITIAL_LIQUIDATION_QUEUE: LiquidationQueueEntry[] = ADMIN_LIQUIDATION_QUEUE;
